export const CHILD_RELATIONS_OPTIONS = [
  { value: 'father', label: '父' },
  { value: 'mother', label: '母' },
  { value: 'grandmother', label: '祖母' },
  { value: 'grandfather', label: '祖父' },
  { value: 'aunt', label: '叔母' },
  { value: 'uncle', label: '叔父' },
  { value: 'other', label: 'その他' },
];
